<div class="new-tasks-notification" *ngIf="hasNewTasksIds">
  <div>
    <button (click)="reloadTaskList(false)" data-testid="new-messages-notification">
      <mat-icon>refresh</mat-icon>
      <span>
        {{ newTasksIds.size }}
        <span *ngIf="newTasksIds.size <= 1; else plural" translate="inbox/task-list/new-message"></span>
        <ng-template #plural>
          <span translate="inbox/task-list/new-messages"></span>
        </ng-template>
      </span>
    </button>
    <button (click)="closeNotification()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<app-mass-actions
  *ngIf="!isLoading && (taskListMode === taskListModeEnum.Inbox || taskListMode === taskListModeEnum.Search)"
  [loadedTasksIds]="loadedTasksIds"
  [taskListConfiguration]="taskListConfiguration"
  [taskListMode]="taskListMode"
  [tasksById]="tasksById"
  [tasksIds]="tasksIds"></app-mass-actions>

<div class="task-list" cdkScrollable [ngClass]="taskListMode">
  <app-inserts-by-me *ngIf="showInsertsByMe" [taskListConfiguration]="taskListConfiguration"></app-inserts-by-me>
  <div *ngIf="!isLoading; else spinner" [attr.data-testid]="'task-list'">
    <ng-container *ngIf="loadedTasksIds && loadedTasksIds.length; else noresult">
      <div *ngFor="let taskId of loadedTasksIds; index as i" class="task">
        <mat-divider></mat-divider>
        <app-task-in-list
          [task]="tasksById[taskId]"
          [taskListConfiguration]="taskListConfiguration"
          [taskListMode]="taskListMode"
          [attr.data-testid]="'task-' + i"
          [id]="'task-' + taskId"></app-task-in-list>
      </div>
      <mat-divider></mat-divider>
    </ng-container>
    <ng-template #noresult>
      <div
        *ngIf="taskListMode === taskListModeEnum.Inbox || taskListMode === taskListModeEnum.Pushbox"
        class="no-result">
        <div class="magic">🪄</div>
        <div class="congrats" translate="inbox/task-list/no-result/congrats"></div>
        <div translate="inbox/task-list/no-result/no-message"></div>
        <div
          class="has-filters"
          *ngIf="isFiltersSelected"
          (click)="resetFilters($event)"
          [innerHTML]="'inbox/task-list/no-result/filters' | translate"></div>
        <div
          *ngIf="redirectTextAndLink"
          class="go-to-received"
          (click)="goToReceived($event)"
          [innerHTML]="redirectTextAndLink"></div>
      </div>
    </ng-template>
  </div>
  <ng-template #spinner>
    <div class="alc-spinner-wrapper">
      <mat-spinner diameter="50" color="primary"></mat-spinner>
    </div>
  </ng-template>
  <!-- TODO remove and manage infinite scroll when search page is full angular -->
  <div class="load-more-tasks">
    <button
      mat-raised-button
      color="primary"
      *ngIf="
        taskListMode === taskListModeEnum.Search &&
        !isLoading &&
        tasksIds.length > 0 &&
        tasksIds.length !== loadedTasksIds.length
      "
      (click)="loadMoreTasks()"
      translate="inbox/task-list/load-more-messages"></button>
  </div>
</div>
<div class="loading-more-tasks" *ngIf="isLoadingMoreTasks">
  <span translate="inbox/task-list/loading-messages"></span>
</div>
